export const windowMap = {
  TODAY: 0,
  TOMORROW: 1,
  THIS_WEEK: 2,
  IN_15_DAYS: 3,
  YESTERDAY: -1,
  LAST_WEEK: -2,
  AGO_15_DAYS: -3
};

export const hasWindowInfoText = (topic) =>
  (topic.window === windowMap.TODAY || topic.window === windowMap.TOMORROW) &&
  topic.windowCount > 0;
